'use strict';
/* eslint-env browser */

var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ky = require('ky-universal').default;

var _require = require('ipfs-utils/src/env'),
    isBrowser = _require.isBrowser,
    isWebWorker = _require.isWebWorker;

var toUri = require('multiaddr-to-uri');

var errorHandler = require('./error-handler');

var mergeOptions = require('merge-options').bind({
  ignoreUndefined: true
});

var parseDuration = require('parse-duration'); // Set default configuration and call create function with them


module.exports = function (create) {
  return function (config) {
    config = config || {};

    if (typeof config === 'string') {
      config = {
        apiAddr: config
      };
    } else if (config.constructor && config.constructor.isMultiaddr) {
      config = {
        apiAddr: config
      };
    } else {
      config = _objectSpread({}, config);
    }

    config.apiAddr = (config.apiAddr || getDefaultApiAddr(config)).toString();
    config.apiAddr = config.apiAddr.startsWith('/') ? toUri(config.apiAddr) : config.apiAddr;
    config.apiAddr = trimEnd(config.apiAddr, '/');
    var apiAddrPath = getNonRootPath(config.apiAddr); // Use configured apiPath, or path on the end of apiAddr (if there is one) or default to /api/v0

    config.apiPath = config.apiPath || config['api-path'] || apiAddrPath || '/api/v0';
    config.apiPath = trimEnd(config.apiPath, '/'); // If user passed apiAddr with a path, trim it from the end (it is now apiPath)

    config.apiAddr = apiAddrPath ? trimEnd(config.apiAddr, apiAddrPath) : config.apiAddr;
    var defaults = {
      prefixUrl: config.apiAddr + config.apiPath,
      timeout: parseTimeout(config.timeout) || 60000 * 20,
      headers: config.headers,
      hooks: {
        afterResponse: [errorHandler]
      }
    };
    var k = ky.extend(defaults);
    var client = ['get', 'post', 'put', 'delete', 'patch', 'head'].reduce(function (client, key) {
      client[key] = wrap(k[key], defaults);
      return client;
    }, wrap(k, defaults));
    return create(_objectSpread({
      ky: client
    }, config));
  };
};

function getDefaultApiAddr(_ref) {
  var protocol = _ref.protocol,
      host = _ref.host,
      port = _ref.port;

  if (isBrowser || isWebWorker) {
    if (!protocol) {
      protocol = location.protocol.startsWith('http') ? trimEnd(location.protocol, ':') : 'http';
    }

    host = host || location.hostname;
    port = port || location.port;
    return "".concat(protocol, "://").concat(host).concat(port ? ':' + port : '');
  }

  return "".concat(protocol || 'http', "://").concat(host || 'localhost', ":").concat(port || 5001);
} // returns the passed function wrapped in a function that ignores
// undefined values in the passed `options` object


function wrap(fn, defaults) {
  return function (input, options) {
    if (options.timeout) options.timeout = parseTimeout(options.timeout);
    return fn(input, mergeOptions(defaults, options));
  };
}

function parseTimeout(value) {
  return typeof value === 'string' ? parseDuration(value) : value;
}

var trimEnd = function trimEnd(str, end) {
  return str.endsWith(end) ? str.slice(0, -end.length) : str;
}; // Get the path from a URL is it is not /


function getNonRootPath(url) {
  if (url) {
    var _URL = new URL(url),
        pathname = _URL.pathname;

    return pathname === '/' ? null : pathname;
  }
}